export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4041d67f2d2a217ec6287e29c21416bb6a2443d80f&name=revalidateCommunity!'